export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 60,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_deliveryDate') || '到货日期',
    field: 'deliveryDate',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    required: 'validRules',
    sortable: true,
    sortType: 'string',
    editRender: {
      name: 'ElDatePicker',
      props: {
        type: 'date',
        'value-format': 'yyyy-MM-dd',
        style: 'width: 100%',
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_beginShippingDate') || '最早出运日期',
    field: 'beginShippingDate',
    headerAlign: 'center',
    align: 'center',
    width: 110,
  },
  {
    title: that.$l('table_label_endShippingDate') || '截至出运日期',
    field: 'endShippingDate',
    headerAlign: 'center',
    align: 'center',
    width: 110,
  },
  {
    title: that.$l('table_label_planContainerQty') || '货柜数量',
    field: 'planContainerQty',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),

  },
  {
    title: that.$l('table_label_planUnitQty') || '产品数量',
    field: 'planUnitQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 110,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_planSpecQty') || '规格数量',
    field: 'planSpecQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 110,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
